import { DropdownAction } from "./types";

export interface SplitActions {
  regular: DropdownAction[];
  destructive: DropdownAction[];
  ordered: DropdownAction[];
}

export const splitDropdownActions = (
  actions: DropdownAction[],
): SplitActions => {
  // `show` is optional, so omitting it means visible — menu and sheet must agree.
  const visible = actions.filter((action) => action.show !== false);
  const regular = visible.filter((action) => action.variant !== "destructive");
  const destructive = visible.filter(
    (action) => action.variant === "destructive",
  );

  // Menu order, not prop order: arrow keys walk what the separator puts on screen.
  return { regular, destructive, ordered: [...regular, ...destructive] };
};

export const firstEnabledFrom = (
  actions: DropdownAction[],
  start: number,
  step: number,
): number => {
  const count = actions.length;
  if (count === 0) {
    return -1;
  }

  for (let offset = 0; offset < count; offset += 1) {
    const index = (((start + step * offset) % count) + count) % count;
    if (!actions[index].disabled) {
      return index;
    }
  }

  return -1;
};
